import { render, staticRenderFns } from "./MerchantOpenCard.vue?vue&type=template&id=95393952&scoped=true&"
import script from "./MerchantOpenCard.vue?vue&type=script&lang=js&"
export * from "./MerchantOpenCard.vue?vue&type=script&lang=js&"
import style0 from "./MerchantOpenCard.vue?vue&type=style&index=0&id=95393952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95393952",
  null
  
)

export default component.exports